import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Link } from 'react-router-dom'
import { Layout, Menu, Col, Dropdown, Button, Icon } from 'antd'

import { PredictionConfigEditor } from './PredictionConfigEditor'
import * as predictionConfigActions from '../../Admin/PredictionConfigs'

const { Header, Content } = Layout

const privateRoutes = [
	{ name: 'DICIDIO', path: '/admin', exact: true, className: 'logo menuItem', },
]

export class PredictionConfigEditorPage extends React.Component {
	state = {
		collapsed: false,
		selected: this.props.location.pathname
	};

	componentDidMount() {
		
	}

	handleClick = (e) => {
		this.setState({
			selected: e.key
		})
	}

	render() {

		return (
			<React.Fragment >
				<Header className='header' style={{ lineHeight: '64px' }} >
					<Col span={20}>
						<Menu theme="dark"
							onClick={this.handleClick}
							selectedKeys={[this.state.selected]}
							mode="horizontal" >
							{
								privateRoutes.map(item => <Menu.Item key={item.path} title={item.name} className={item.className}><Link to={item.path}>{item.name}</Link></Menu.Item>)
							}

						</Menu>
					</Col>
					<Col>
						<Dropdown overlay={
							<Menu theme="dark" >{
								this.props.diagrams[this.props.match.params.id].actions.map(item =>
									<Menu.Item
										key={item.key}
										title={item.key}
										onClick={item.onClick ? item.onClick : undefined}
										className={item.className}>
										{
											item.path ?
												<Link to={item.path}>{item.key}</Link>
												: <div>{item.key}</div>
										}
									</Menu.Item>
								)
							}
							</Menu>
						}><Button>Actions<Icon type='down'></Icon></Button>
						</Dropdown></Col>
				</Header>
				<Content >
					<PredictionConfigEditor
						id={this.props.match.params.id}
					/>
				) :
				(<div>loading...</div>)}

				</Content>
			</React.Fragment>
		)
	}
}

PredictionConfigEditorPage = connect(
	(state, props) => ({
		predictionConfig: state.predictionConfigs.items[props.match.params.id],
		diagrams: this.state.diagrams.instances,
	}),
	dispatch => (
		bindActionCreators({ ...predictionConfigActions, }, dispatch)
	)
)(PredictionConfigEditorPage)




// WEBPACK FOOTER //
// ./src/App/SolutionEditor/Predictions/PredictionConfigEditorPage.jsx